var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.789 21.111C14.8037 19.4443 14.9796 18.2351 15.3167 17.4833C15.6538 16.7316 16.3149 15.9112 17.3 15.0223C18.226 14.1926 18.9352 13.4388 19.4277 12.761C19.9203 12.0832 20.1667 11.3443 20.1667 10.5443C20.1667 9.57411 19.8426 8.76678 19.1943 8.12233C18.5463 7.47789 17.6408 7.15567 16.4777 7.15567C15.3297 7.15567 14.4501 7.489 13.839 8.15567C13.2279 8.82233 12.7852 9.51122 12.511 10.2223L9.5 8.911C9.98156 7.563 10.8186 6.40745 12.011 5.44433C13.2037 4.48145 14.6926 4 16.4777 4C18.737 4 20.4759 4.62778 21.6943 5.88333C22.913 7.13889 23.5223 8.64811 23.5223 10.411C23.5223 11.4926 23.2908 12.4537 22.8277 13.2943C22.3648 14.1352 21.6297 15.0408 20.6223 16.011C19.5334 17.0554 18.876 17.8537 18.65 18.4057C18.424 18.9574 18.3037 19.8592 18.289 21.111H14.789ZM16.4777 29.3333C15.8037 29.3333 15.2278 29.0944 14.75 28.6167C14.2722 28.1389 14.0333 27.563 14.0333 26.889C14.0333 26.2148 14.2722 25.6388 14.75 25.161C15.2278 24.6832 15.8037 24.4443 16.4777 24.4443C17.1519 24.4443 17.7279 24.6832 18.2057 25.161C18.6834 25.6388 18.9223 26.2148 18.9223 26.889C18.9223 27.563 18.6834 28.1389 18.2057 28.6167C17.7279 29.0944 17.1519 29.3333 16.4777 29.3333Z",
    fill: "#3F41D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.3008b7572b347cf4c8d4d47bd79069c3.svg";
export { ForwardRef as ReactComponent };